export default __webpack_public_path__ + "static/media/sat-5.6836f40d.gif";